type RingProps = {
  /** total number of segments (e.g. 7 for a weekly ring) */
  segments: number;
  /** how many segments, from index 0, are filled/done */
  filled: number;
  /** index of the segment to render as "current" (pulsing), if any */
  current?: number;
  size?: number;
  strokeWidth?: number;
  centerLabel?: string;
};

/** Segmented progress ring. Used for the weekly ring and session progress. */
export function Ring({ segments, filled, current, size = 96, strokeWidth = 8, centerLabel }: RingProps) {
  const r = (size - strokeWidth) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  const gapDeg = Math.min(6, 360 / segments / 4);
  const segDeg = 360 / segments - gapDeg;
  const arcLen = (segDeg / 360) * circumference;
  const dashArray = `${arcLen} ${circumference - arcLen}`;

  return (
    <svg class="ring" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle class="ring-track" cx={cx} cy={cy} r={r} stroke-width={strokeWidth} opacity={0} />
      {Array.from({ length: segments }, (_, i) => {
        const rotate = -90 + i * (360 / segments);
        const done = i < filled;
        const isCurrent = current === i;
        const cls = ["ring-seg", done && "ring-seg-done", isCurrent && "ring-seg-current"]
          .filter(Boolean)
          .join(" ");
        return (
          <circle
            key={i}
            class={cls}
            cx={cx}
            cy={cy}
            r={r}
            stroke-width={strokeWidth}
            stroke-dasharray={dashArray}
            stroke-linecap="round"
            transform={`rotate(${rotate} ${cx} ${cy})`}
          />
        );
      })}
      {centerLabel && (
        <text x={cx} y={cy + 4} text-anchor="middle" class="ring-center">
          {centerLabel}
        </text>
      )}
    </svg>
  );
}
